import { useEventBus } from '@vueuse/core'

const model = ref(false)
const paymentDialogCloseBus = useEventBus<void>('payment-dialog-close')

export const usePaymentDialog = () => {
  const show = () => {
    model.value = true
  }

  const hide = () => {
    model.value = false
  }

  const onClose = (callback: () => void) => {
    return paymentDialogCloseBus.on(callback)
  }

  const emitClose = () => {
    paymentDialogCloseBus.emit()
  }

  return {
    model,
    show,
    hide,
    onClose,
    emitClose,
  }
}
